import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/tsubaki-2.styles')

export const handle = {
  name: 'tsubaki-2/styles',
  track: { scene: 'model-landing', section: 'tsubaki-2' },
}

export default dynamic(getClientModule, { ssr: false })
